<template>
  <div class="field">
    <label
      v-if="label"
      class="mb-2 label"
      :for="name"
    >
      <h3>
        {{ label }}
      </h3>
    </label>
    <div class="color-select">
      <input
        v-model="model"
        :disabled="isDisabled"
        type="color"
      />
      <input
        :id="name"
        v-model="model"
        class="form-control"
        :disabled="isDisabled"
        :maxlength="7"
        type="text"
      />
    </div>
  </div>
</template>

<script>
import commonProperties from './common-properties';

export default {
  name: 'ColorPicker',
  mixins: [commonProperties],
  inheritAttrs: false,
};
</script>

<style scoped lang="scss">
h3 {
  font-weight: $lb-medium;
  font-size: $size-normal;
  line-height: 1.5;
  color: $dark;
}

.color-select {
  display: flex;
  align-items: center;
}

input[type='color'] {
  -webkit-appearance: none;
  cursor: pointer;
  width: 26px;
  height: 26px;
  border: 2px solid $dark;
  border-radius: 50%;
  margin-right: 10px;
  padding: 0px;

  &::-moz-color-swatch {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    border: none;
  }
}

input[type='color']::-webkit-color-swatch-wrapper {
  border: none;
  border-radius: 50%;
  padding: 0;
}

input[type='color']::-webkit-color-swatch {
  border: none;
  border-radius: 50%;
  padding: 0;
}

input[type='text'] {
  max-width: 128px;
  background-color: $lighter;
  border: 1px solid $light;
  color: $darker;
  border-radius: 4px;
  padding: 10px 16px;

  &::placeholder {
    color: $light;
    font-size: $size-smaller;
  }

  &:focus {
    border-color: $crm-blue-primary;
  }
}
</style>
